const url = "/seguranca/contasacesso";

export function buscarPorNomeEmailCpf(postBody,page,size) {

    return new Promise((resolve, reject) => {
        window.$http.post(`${url}/buscarNomeEmailCpf?page=${page}&size=${size}`, JSON.stringify(postBody))
            .then((res) => {
                resolve(res.data);
            });
    })
}